import React from 'react';
import { siteData } from '../mock';
import { Twitter, Youtube, Instagram, Twitch, Music } from 'lucide-react';

const SocialLinks = () => {
  const iconMap = {
    Twitter: Twitter,
    Youtube: Youtube,
    Instagram: Instagram,
    Twitch: Twitch,
    Music: Music
  };

  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col gap-4">
      {siteData.socials.map((social) => {
        const Icon = iconMap[social.icon];
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-button group"
            aria-label={social.name}
          >
            <Icon size={20} className="transition-transform group-hover:scale-110" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
